import styled from 'styled-components';

const SessionDrawerContainer = styled.div`
  margin: ${(props) => (props.marginSessionDrawer ? props.marginSessionDrawer : '0')};
  .title {
    display: block;
    color: #3c71dd;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 114.286% */

    border-bottom: 0.5px solid #3c71dd;
    width: ${(props) => (props.width ? props.width : '0')};
    margin: ${(props) => (props.marginTitle ? props.marginTitle : '0')};
  }
`;

export const SessionDrawer = ({
  children,
  configSessionDrawer = {
    width: '',
    title: '',
    marginTitle: '',
    marginSessionDrawer: '',
  },
}) => {
  return (
    <SessionDrawerContainer
      width={configSessionDrawer.width}
      marginTitle={configSessionDrawer.marginTitle}
      marginSessionDrawer={configSessionDrawer.marginSessionDrawer}
    >
      <span className="title">{configSessionDrawer.title}</span>
      {children}
    </SessionDrawerContainer>
  );
};
